import React from 'react';
import classNames from 'classnames';
import './donutSpinner.css';
function DonutSpinner(_a) {
    var _b;
    var className = _a.className;
    var main = classNames((_b = {
            'donut': true
        },
        _b[className] = className,
        _b));
    return (React.createElement("div", { className: main }));
}
export default DonutSpinner;
